<template>
  <wrap-container>
    <form-validator>
      <div id="escribenosConsulta">Escribinos tu consulta</div>
      <!--INICIO BLOQUE EMPRESAS -->
      <wrap-container>
        <wrap-container class="grid-container grid-container--6-6">
          <number-input
            class="col1"
            label="CUIT Empresa *"
            v-model="model.cuitEmpresa"
            :disabled="paramsCash.cuitEmpresa != null"
            name="cuit-empresa"
            maxlength="11"
            minlength="11"
            :required="true"
          />
          <text-input
            class="col2"
            label="Razon Social *"
            v-model="model.razonSocial"
            :disabled="paramsCash.razonSocial != null"
            name="Razon Social"
            maxlength="100"
            :required="true"
          />
        </wrap-container>
      </wrap-container>
      <!--FIN BLOQUE EMPRESAS -->
      <wrap-container class="grid-container grid-container--6-6">
        <text-input
          class="col1"
          label="Nombre *"
          hint="Ingresá tu nombre"
          v-model="model.nombre"
          :disabled="paramsCash.nombre != null"
          name="nombre"
          maxlength="50"
          :required="true"
        />
        <text-input
          class="col2"
          label="Apellido *"
          hint="Ingresá tu apellido"
          v-model="model.apellido"
          :disabled="paramsCash.apellido != null"
          name="apellido"
          maxlength="50"
          :required="true"
        />
      </wrap-container>
      <email-field
        class="col1"
        label="Email *"
        v-model="model.email"
        :disabled="paramsCash.email != null"
        name="email"
        :required="true"
        maxlength="1000"
      />

      <!-- INICIO BLOQUE EMPRESAS -->

      <!--FIN BLOQUE EMPRESAS -->
      <wrap-container>
        <section-label value="Teléfono celular de contacto" />
        <phone-number
          v-model="model.celular"
          :required="true"
          subhint="El número debe ser de Argentina"
          fieldNumero="Número"
          fieldArea="Cód. de área"
        />
        <!--FIN BLOQUE EMPRESAS -->

        <!--INICIO BLOQUE EMPRESAS -->
        <wrap-container>
          <span>¿En qué podemos ayudarte?</span><br /><br />
          <details-input
            class="col1"
            label="Mensaje"
            hint="En caso de error, por favor indicar el mensaje textual, la fecha y la hora en la que se realizó la operación."
            v-model="model.mensaje"
            name="mensaje"
            maxlength="600"
            :required="true"
          />
        </wrap-container>
      </wrap-container>
      <FileUpload @fileChange="actualizarPropsArchivo" />
      <br />
      <div
        id="archivosPermitidos"
        style="display: flex; align-items: flex-start"
      >
        <svg
          viewBox="0 0 260 260"
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
          style="
            pointer-events: none;
            width: 1.23rem;
            height: 1.23rem;
            overflow: hidden;
            margin-right: 0.5rem;
            margin-bottom: 0;
          "
          aria-hidden="true"
        >
          <path
            d="M130 10a120 120 0 1 0 120 120A120 120 0 0 0 130 10Zm10 190-20-20v-70h20ZM130 90a15 15 0 1 1 15-15 15 15 0 0 1-15 15Z"
            fill="#004481"
          ></path>
        </svg>
        <span
          >El formato del archivo debe ser JPG, PNG, GIF, PDF, DOC, DOCX y TXT
          con un máximo de 2MB</span
        >
      </div>

      <div style="padding: 40px 0">
        <span>Al enviar acepto los </span>
        <span id="tycRedirect" @click="scrollToDiv"
          >términos y condiciones</span
        >
        <span> del tratamiento de datos.</span>
      </div>

      <!--FIN BLOQUE EMPRESAS -->
      <span class="error" v-if="errorFormulario">
        <img src="@/assets/img/1x/error_icon.png" :alt="error" />
        <span> Ocurrió un error al enviar el formulario</span>
        <ul v-for="(item, index) in textoError" v-bind:key="index">
          <li>{{ item }}</li>
        </ul>
      </span>

      <wrap-container class="buttonEnviar">
        <sales-button
          label="Enviar"
          @click="validarRecaptcha"
          color="#1973B8"
        />
      </wrap-container>
    </form-validator>
    <lottie-loader v-if="loading" />
    <wrap-container class="recaptcha">
      <vue-recaptcha
        ref="recaptcha"
        sitekey="6Lfp-yUUAAAAAFcXnw7yb4EhrGGz0zmF3SZhqViW"
        size="invisible"
        badge="inline"
        @verify="enviarForm"
      ></vue-recaptcha>
    </wrap-container>
    <WrapContainer class="terminosCondiciones">
      <div id="terminosCondiciones" ref="terminosCondicionesRef">
        <br /><br /><span>Terminos y condiciones de tratamiento de datos</span
        ><br /><br />
        <span>Tratamiento de Datos Personales</span>
        <p>
          Los datos personales aquí incluidos tienen el carácter de declaración
          jurada y son recogidos para ser incorporados y tratados en una base de
          datos, la cual se encuentra registrada en la Agencia de Acceso a la
          Información Pública, cuyo destinatario y titular es Banco BBVA
          Argentina S.A. Cualquier falseamiento, error y/o inexactitud respecto
          a la información implicará la supresión de estos datos de la base de
          referencia y no podrán ser utilizados a futuro. El Cliente presta su
          consentimiento expreso al Banco, para que toda la información
          referente a su persona, sus actividades económicas o las operaciones
          que haya concertado o que concierte en el futuro (en adelante y en su
          conjunto "la información") pueda ser transferida y cedida, aún en
          forma gratuita, dentro de estrictas políticas de confidencialidad y
          seguridad de los datos, a sus afiliadas, subsidiarias, controlantes,
          controladas y/o cualquier tercero. La información podrá ser utilizada
          para: a) La realización de segmentaciones o perfiles del Cliente con
          fines comerciales a efectos de adaptar los productos o servicios a
          necesidades o características específicas, así como con fines de
          análisis de riesgos para evaluar nuevas operaciones, en ambos
          supuestos conservando dichas segmentaciones o perfiles en tanto y en
          cuanto el interviniente mantenga relación contractual con el Banco,
          pudiendo oponerse en cualquier momento a dicho tratamiento; b) El
          envío a través de cualquier medio, por parte del Banco o de otros
          terceros, de ofertas comerciales, distintos tipos de informaciones o
          publicidades, personalizadas o no, sobre productos o servicios propios
          o de terceros; c) Para cualquier otra finalidad no incompatible con
          las especificadas anteriormente. Cuando así lo disponga, el Cliente
          tendrá el derecho de acceder a la información y solicitar su
          rectificación o supresión de la base de archivo. El Banco informa al
          Cliente que sus datos personales podrán ser cedidos a las autoridades
          competentes cuando las leyes o regulaciones de aplicación así lo
          establezcan. El Cliente, en su caracter de titular de sus datos
          personales tiene el derecho de acceso a los mismos en forma gratuita
          en intervalos no inferiores a seis meses, salvo que se acredite un
          interés legítimo al efecto conforme lo establecido en el artículo 14,
          inciso 3 de la Ley 25.326. La AGENCIA DE ACCESO A LA INFORMACIÓN
          PÚBLICA, Órgano de Control de la Ley Nº 25.326, tiene la atribución de
          atender las denuncias y reclamos que se interpongan con relación al
          incumplimiento de las normas sobre protección de datos personales. En
          función del Estándar de la Organización para la Cooperación y
          Desarrollo Económicos (OCDE) para el Intercambio Automático de
          Información en Asuntos Fiscales y de las disposiciones de la Ley de
          cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax
          Compliance Act” - FATCA) de los Estados Unidos de América, el Cliente
          autoriza al Banco a ceder información a autoridades de terceros países
          por operatorias desarrolladas en los mercados internacionales tales
          como Estados Unidos. Lo expuesto, ya sea de forma agregada o
          individual, según el caso.
        </p>
        <span>Sistemas de Biometría:</span>
        <p>
          En caso de que el Banco defina el uso de dispositivos para la captura,
          lectura y/o procesamiento de datos –inclusive aquellos de carácter
          biométricos– en alguno de sus procesos operativos y/o de seguridad
          aplicables, El Cliente autoriza al Banco a compartir estos datos con
          terceros exclusivamente para el resguardo de la información capturada,
          la verificación de la identidad del titular de los datos, con
          intenciones publicitarias y/o con los fines que el Banco determine.
        </p>
        <span>Sistemas de información crediticia:</span>
        <p>
          Ante la solicitud de cualquier producto, el Banco puede solicitar
          información a las agencias de informes comerciales a fin de evaluar la
          situación crediticia del Cliente. El Cliente acepta que estará sujeto
          a la clasificación e inclusión en la Central de Deudores del Sistema
          Financiero de conformidad a la normativa vigente del B.C.R.A., dado
          que es obligación del Banco informar, solamente, al Banco Central de
          la República Argentina todos los datos que éste le requiera o que
          pudiera requerirle en el futuro, relacionados con sus Clientes. No
          será responsabilidad del Banco la utilización de la información del
          Cliente por parte de terceros distintos al B.C.R.A., dado que la misma
          no es proporcionada por el Banco.
        </p>
      </div>
    </WrapContainer>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import LottieLoader from "@/components/core/LottieLoader";
import FormValidator from "@/components/core/FormValidator";
import TextInput from "@/components/core/TextInput";
import EmailField from "@/components/core/EmailField";
import PhoneNumber from "@/components/core/composite/PhoneNumber.vue";
import DetailsInput from "@/components/core/DetailsInput";
import SectionLabel from "@/components/core/SectionLabel";
import SalesButton from "@/components/core/SalesButton";
import NumberInput from "@/components/core/NumberInput";
import VueRecaptcha from "vue-recaptcha";
import API from "@/api";
import { getParameterByNameIgnoringNull } from "@/utils";
import FileUpload from "@/components/core/custom/FileUpload";

export default {
  watch: {
    "$route.query"(query) {
      if (query.id) {
        this.scrollTo(query.id);
      }
    }
  },
  name: "FormularioContacto",
  props: {
    tipo: {
      type: String,
      default: "consulta"
    }
  },
  components: {
    WrapContainer,
    FormValidator,
    LottieLoader,
    TextInput,
    EmailField,
    PhoneNumber,
    SectionLabel,
    SalesButton,
    DetailsInput,
    NumberInput,
    VueRecaptcha,
    FileUpload
  },
  data() {
    return {
      mostrarFileUpload: true,
      files: [],
      textoError: ["Inténtelo nuevamente más tarde."],
      loading: false,
      errorFormulario: false,
      fileName: "",
      fileBase64: "",
      paramsCash: {
        apellido: getParameterByNameIgnoringNull("apellido"),
        nombre: getParameterByNameIgnoringNull("nombre"),
        email: getParameterByNameIgnoringNull("mail", null, true),
        cuitEmpresa: getParameterByNameIgnoringNull("cuit"),
        razonSocial: getParameterByNameIgnoringNull("razSoc"),
        nroAltamira: getParameterByNameIgnoringNull("nroAltamira")
      },
      model: {
        apellido: "",
        nombre: "",
        email: "",
        celular: {
          area: "",
          numero: ""
        },
        cuitEmpresa: "",
        razonSocial: "",
        mensaje: ""
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToDiv() {
      this.$refs.terminosCondicionesRef.scrollIntoView({ behavior: "smooth" });
    },
    validarRecaptcha() {
      this.$refs.recaptcha.reset();
      this.loading = true;
      this.$refs.recaptcha.execute();
    },
    actualizarPropsArchivo(fileData) {
      this.fileName = fileData.fileName;
      this.fileBase64 = fileData.fileBase64;
    },
    enviarForm(token) {
      const payload = {
        datos: this.model,
        token
      };
      //se envia tipo de consulta vacio para que no falle en SF
      payload.tipoConsulta = " ";
      payload.datos.enviadoDesde = "ALTA_100_DIG";
      payload.datos.ayudaLabel = "DIGITAL";
      payload.datos.temaLabel = "CUENTAS";
      payload.datos.subtemaLabel = "CARGA DE INFORMACION POR WEB";
      payload.datos.ayuda = "9001";
      payload.datos.tema = "900110035";
      payload.datos.subtema = "9001100359002";
      payload.datos.nombreAdjunto = this.fileName;
      payload.datos.archivoAdjunto = this.fileBase64;

      const endPoint = "formularioConsultaEmpresas/consulta";
      API.request({ endPoint, payload })
        .then(response => {
          this.loading = false;
          if (String(response.data) === "true") {
            this.$router.push({
              name: "gracias",
              params: {
                tipoGracias: "consultaRecibida",
                email: this.model.email,
                nombre: this.model.nombre
              }
            });
          } else {
            window.scrollTo(0, document.body.scrollHeight - 1000);
            //Se muestra mensaje de error
            this.errorFormulario = true;
          }
        })
        .catch(() => {
          this.loading = false;
          window.scrollTo(0, document.body.scrollHeight - 1000);
          //Se muestra mensaje de error
          this.errorFormulario = true;
        });
    }
  },
  created() {
    (this.model.apellido = this.paramsCash.apellido),
      (this.model.nombre = this.paramsCash.nombre),
      (this.model.email = this.paramsCash.email),
      (this.model.cuitEmpresa = this.paramsCash.cuitEmpresa),
      (this.model.razonSocial = this.paramsCash.razonSocial),
      (this.model.nroAltamira = this.paramsCash.nroAltamira),
      (this.model.fromNetCash = this.paramsCash.fromNetCash);
  }
};
</script>
<style scoped>
#mensajeAlert {
  background-color: #d5ecff;
  padding: 10px;
  line-height: 24px;
  display: flex;
  margin-bottom: 10px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 15px;
}

#mensajeAlert img {
  margin: 1px 16px 5px 0px;
}

#mensajeAlert p {
  margin: 0px;
}

span.error {
  background: #fcdfdf;
  margin: 8px 8px 20px 0px;
  padding: 12px;
  display: block;
}

.recaptcha {
  margin-top: 32px;
  margin-bottom: 32px;
  opacity: 0.3;
}

#mensajeAlert {
  background-color: #d5ecff;
  padding: 10px;
  line-height: 24px;
  display: flex;
  margin-bottom: 10px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 15px;
}

#mensajeAlert img {
  margin: 1px 16px 5px 0px;
}

#mensajeAlert p {
  margin: 0px;
}

#archivosPermitidos {
  font-family: BentonSansBBVA-Light, Helvetica, Arial, sans-serif;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
}

.terminosCondiciones {
  box-sizing: border-box;
  width: 100%;
}

.buttonEnviar {
  width: 128px;
}

#tycRedirect {
  color: #1973b8;
}

#tycRedirect:hover {
  cursor: pointer;
}

#escribenosConsulta {
  margin-bottom: 48px;
  margin-top: 0px;
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 26px;
  color: #121212;
}
</style>
